export default function CheckDevice() {
    return (
        window.innerWidth <= 950 ||
        window.innerHeight <= 500 ||
        navigator.userAgent.match(/iPhone/i)
    );
}
